module.exports = __webpack_public_path__ + "img/手指.74a5bc97.png";